import React, { useState } from "react";
import { KeyRound, LockKeyhole, ShieldCheck } from "lucide-react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function SecuritySection({
  currentPassword, newPassword, confirmPassword, passwordError, passwordSuccess, passwordLoading,
  onCurrentPasswordChange, onNewPasswordChange, onConfirmPasswordChange, onSubmit
}) {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const inputShellClassName = "rounded-xl border border-slate-200 bg-white/90 px-3 py-2 shadow-sm transition focus-within:border-slate-400 focus-within:shadow-[0_0_0_3px_rgba(148,163,184,0.09)]";
  const inputClassName = "mt-0.5 w-full border-none bg-transparent p-0 pr-9 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none";
  const toggleClassName = "absolute right-0 top-1/2 -translate-y-1/2 inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-400 transition hover:bg-slate-100 hover:text-gray-600";

  return (
    <form className="flex flex-col gap-3 px-5 pb-5" onSubmit={onSubmit} autoComplete="off">
      <div className={inputShellClassName}>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
            <LockKeyhole className="h-4.5 w-4.5" />
          </span>
          <div className="relative min-w-0 flex-1">
            <label className="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400">
              Current Password
            </label>
            <input
              type={showCurrentPassword ? "text" : "password"}
              placeholder="Enter current password"
              className={inputClassName}
              value={currentPassword}
              onChange={onCurrentPasswordChange}
              autoComplete="current-password"
            />
            <button
              type="button"
              onClick={() => setShowCurrentPassword((prev) => !prev)}
              className={toggleClassName}
              aria-label={showCurrentPassword ? "Hide current password" : "Show current password"}
            >
              {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
      </div>
      <div className={inputShellClassName}>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
            <KeyRound className="h-4.5 w-4.5" />
          </span>
          <div className="relative min-w-0 flex-1">
            <label className="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400">
              New Password
            </label>
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="Create a new password"
              className={inputClassName}
              value={newPassword}
              onChange={onNewPasswordChange}
              autoComplete="new-password"
            />
            <button
              type="button"
              onClick={() => setShowNewPassword((prev) => !prev)}
              className={toggleClassName}
              aria-label={showNewPassword ? "Hide new password" : "Show new password"}
            >
              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
      </div>
      <div className={inputShellClassName}>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
            <ShieldCheck className="h-4.5 w-4.5" />
          </span>
          <div className="relative min-w-0 flex-1">
            <label className="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400">
              Confirm Password
            </label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm new password"
              className={inputClassName}
              value={confirmPassword}
              onChange={onConfirmPasswordChange}
              autoComplete="new-password"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
              className={toggleClassName}
              aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
      </div>
      {passwordError && <div className="text-xs text-red-500 mt-1">{passwordError}</div>}
      {passwordSuccess && <div className="text-xs text-emerald-600 mt-1">{passwordSuccess}</div>}
      <button type="submit" disabled={passwordLoading} className="mt-2 px-5 py-2 bg-[#f1f1f4] text-gray-700 rounded-xl hover:bg-blue-50 border border-gray-200 text-base font-medium transition disabled:cursor-not-allowed disabled:opacity-70">{passwordLoading ? "Changing..." : "Change Password"}</button>
    </form>
  );
}
